module.exports = __webpack_public_path__ + "static/img/votano-connor.b03f290.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/votano-connor.jpg
// module id = TU2H
// module chunks = 0